/* eslint-disable no-console */
// TODO: Remove above
import actions, { AuthenticationState } from './constants';

export const userExpired = () => { console.log('userExpired'); };

export const userFound = (user) => ({ type: actions.LOGIN_SUCCESS, payload: user });

export const silentRenewError = () => { console.log('silentRenewError'); };

export const sessionTerminated = () => { console.log('sessionTerminated'); };

export const userExpiring = () => { console.log('userExpiring'); };

export const idTokenAcquired = (token) => ({
  type: actions.ACQUIRED_ID_TOKEN_SUCCESS,
  payload: { idToken: { rawIdToken: token } },
});

export const userSignedOut = () => ({
  type: actions.AUTHENTICATED_STATE_CHANGED,
  payload: AuthenticationState.Unauthenticated,
});

export const userSignedIn = () => ({
  type: actions.AUTHENTICATED_STATE_CHANGED,
  payload: AuthenticationState.Authenticated,
});

export const inProgress = () => ({
  type: actions.AUTHENTICATED_STATE_CHANGED,
  payload: AuthenticationState.InProgress,
});

export const initializing = () => ({ type: actions.INITIALIZING });

export const initialized = () => ({ type: actions.INITIALIZED });
